

require("../bootstrap");
require("../plugins");
require("owl.carousel");
require('persian-date');
require('ion-rangeslider')
require('three');
require("select2");
require("typewriter-effect");
 

import Vue from "vue";
import AOS from "aos";
import Toastify from 'toastify-js';
import Select2 from "select2";
import ApexCharts from "apexcharts";
import ionRangeSlider from "ion-rangeslider";
import * as THREE from 'three';
import Typewriter from 'typewriter-effect/dist/core';
import Alpine from 'alpinejs'
import 'bootstrap-icons/font/bootstrap-icons.css';

window.THREE = THREE;
window.Select2 = Select2;
window.Typewriter = Typewriter;
window.Alpine = Alpine;
window.ApexCharts = ApexCharts;
Alpine.start()


Vue.component(
    "example-component",
    require("./components/ExampleComponent.vue").default
);


const app = new Vue({
    el: "#vue-app",
});

AOS.init({
    duration: 900, // values from 0 to 3000, with step 50ms
});

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
window.Pusher = Pusher;
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: '8bc3903844e728d7801c',
    cluster: 'mt1',
    wsHost: 'ws.skycloud.ir',
    wsPort: 6001,
    wssPort: 443,
    forceTLS: false,
    enabledTransports: ['ws', 'wss'],
    disableStats: true,
    // auth: {
    //     headers: {
    //         'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    //     }
    // }
});
